// List is from CH-3924
// No exact logic to determine which services should have critical prompts, so we are hardcoding the list for now.

const criticalPromptServices = [
  1, // Photography
  2, // Dusk Photography
  3, // Floorplan
  4, // Copywriting
  10, // Video
  12, // Photography - Portrait
  14, // Photography 2
  15, // Dusk Photography 2
  16, // Floorplan 2
  17, // Photography - Portrait 2
  18, // Copywriting 2
  20, // Companion Floorplan
  22, // Drone Photography
  23, // Drone Videography
  24, // Property Video - Agent Hype
  25, // Drone Photography Budget
  26, // Drone Companion Photography
  27, // Photography - Twilight
  44, // Companion Video
  47, // Companion Photography
  49, // Photography and IVT companion
  50, // Companion Drone Videography
  51, // Companion Drone Photography
  52, // Photography Image Selector
  53, // Content Direct Gallery
  56, // Photography with Companion
  57, // Property Photography with Companion
  58, // Floorplan with Companion
  59, // Prestige Photography with Companion
  60, // Dusk Photography with Companion
  64, // Super Bundle or Property Photography with Pole
]

export default criticalPromptServices